import * as type from "./action-type";
import icon01 from '../../assets/images/home/wordicon01.png'
import icon02 from '../../assets/images/home/wordicon02.png'
import icon03 from '../../assets/images/home/wordicon03.png'
import icon04 from '../../assets/images/home/wordicon04.png'
import icon05 from '../../assets/images/home/wordicon05.png'
import icon06 from '../../assets/images/home/wordicon06.png'
import icon07 from '../../assets/images/home/wordicon07.png'
import icon08 from '../../assets/images/home/wordicon08.png'

let _state = {
    dataCount: {},

    currHotTab: 0,
    // 热门数据Tab
    hotDataTabs: [
        'Demographic Profile',
        'Education Attainments of the Population',
        'Population Aging'
    ],
    censusData: [ // 最新人口普查数据
        {
            icon: icon01,
            name: 'Population',
            itemList: [
                {name: 'Households, Population and Sex Ratio', fileCode: 'N2022060068000005'},
                {name: 'Illiterate Population Aged 15 and Over by Sex', fileCode: 'N2022060068000029'},
                // {name: 'Number of Rooms and Floor Space of Households', fileCode: 'N2022060068000049'}
            ]
        },
        {
            icon: icon02,
            name: 'Ethnic Group',
            itemList: [
                {name: 'Population by Age, Sex and Ethnic Group', fileCode: 'N2022060068000058'},
                {name: 'Population Aged 3 and Over by Sex, Educational Attainment and Ethnic Group', fileCode: 'N2022060068000062'}
            ]
        },
        {
            icon: icon03,
            name: 'Age',
            itemList: [
                {name: 'Population by Age and Sex', fileCode: 'N2022060068000071'},
                {name: 'Population Composition by Age(I)', fileCode: 'N2022060068000075'},
                {name: 'Population Composition by Age(II)', fileCode: 'N2022060068000079'}
            ]
        },
        {
            icon: icon04,
            name: 'Educational Level',
            itemList: [
                {name: 'Population Aged 3 and Over by Age,Sex and Educational Attainment', fileCode: 'N2022060068000084'},
                {name: 'Population Aged 25 and Over by Sex and Educational Attainment', fileCode: 'N2022060068000096'},
                // {name: 'Illiterate population Aged 15 and above by Age and Sex', fileCode: 'N2022060068000100'}
            ]
        },
        {
            icon: icon05,
            name: 'Family',
            itemList: [
                {name: 'Types of Households at Different Scale', fileCode: 'N2022060068000105'},
                {name: 'Single Person Household by Age and Sex ', fileCode: 'N2022060068000109'},
                // {name: 'Number of Households with Aging Population Aged 60 and Above', fileCode: 'N2022060068000117'}
            ]
        },
        {
            icon: icon06,
            name: 'Death',
            itemList: [
                {name: 'Death Population by Age and Sex', fileCode: 'N2022060068000130'},
                {name: 'Death Population Aged 15 and Over by Sex, Marriage Status', fileCode: 'N2022060068000138'},
                // {name: 'National Death Population by Age and Sex', fileCode: 'N2022060068000142'},
            ]
        },
        {
            icon: icon07,
            name: 'Household Registration Status',
            itemList: [
                {name: 'Population with Permanent Household Registration Elsewhere by Current Residence, Household Registration Place and Sex', fileCode: 'N2022060068000147'},
                // {name: 'Population Whose Registration Household is in Other Province by Present Residence Place, Education and Sex', fileCode: 'N2022060068000171'}
            ]
        },
        {
            icon: icon08,
            name: 'Housing',
            itemList: [
                {name: 'Number of Households by Number of Residential Houses', fileCode: 'N2022060068000188'},
                {name: 'Number of Households by Per Capita Housing Area', fileCode: 'N2022060068000192'},
                // {name: 'Housing Conditions of Households by Education of the Householder', fileCode: 'N2022060068000200'},
            ]
        },
    ],

    // 最新人口普查公报数据
    statNews: [],

    //最新普查资料
    yearbookList: [],

    //热门数据
    charts: [null, null, null],
    echart0: {
        title: 'Population and Average Annual Growth Rate from Population Censuses',
        unitBar: '10000 Persons',
        unitLine: '%',
        valuesBar: [
            '58260',
            '69458',
            '100818',
            '113368',
            '126583',
            '133972',
            '141178'
        ],
        valuesLine: [
            '',
            '1.61',
            '2.09',
            '1.48',
            '1.07',
            '0.57',
            '0.53'
        ],
        years: [
            '1953',
            '1964',
            '1982',
            '1990',
            '2000',
            '2010',
            '2020'
        ],
    },
    echart1: {
        title: 'Sex Composition from Population Censuses',
        unitBar: '10000 Persons',
        menValuesBar: [
            '30190',
            '35652',
            '51944',
            '58495',
            '65355',
            '68685',
            '72334'
        ],
        womenValuesBar: [
            '28070',
            '33806',
            '48874',
            '54873',
            '61228',
            '65287',
            '68844'
        ],
        valuesLine: [
            '107.56',
            '105.46',
            '106.3',
            '106.6',
            '106.74',
            '105.2',
            '105.07'
        ],
        years: [
            '1953',
            '1964',
            '1982',
            '1990',
            '2000',
            '2010',
            '2020'
        ]
    },
    echart2: {
        title: 'Urbanization rate from Population Censuses(%)',
        unit: '%',
        values: [
            '13.26',
            '18.30',
            '20.91',
            '26.44',
            '36.22',
            '49.68',
            '63.89'
        ],
        years: [
            '1953',
            '1964',
            '1982',
            '1990',
            '2000',
            '2010',
            '2020'
        ]
    },
    echart3: {
        title: 'Population with Various Education Attainment Per 100 000 Persons from Population Censuses',
        unit: 'Person',
        dataSource: [
            ['product', '1964', '1982', '1990', '2000', '2010', '2020'],
            ['Primary\n School', 28330, 35237, 37057, 35701, 26779, 24767],
            ['Junior \n Secondary \nSchool', 4680, 17892, 23344, 33961, 38788, 34507],
            ['Senior \n Secondary \nSchool', 1319, 6779, 8039, 11146, 14032, 15088],
            ['University', 416, 615, 1422, 3611, 8930, 15467],
            // ['Senior \n Secondary \n School \n (including  \n Secondary Technical \n School)', 1319, 6779, 8039, 11146, 14032, 15088],
            // ['Undergraduates \n (Junior Colleges \n & above)', 416, 615, 1422, 3611, 8930, 15467],
        ],
    },
    echart4: {
        title: 'Educational Status of Ages 3 & above from 2020 Population Census',
        unitBar: 'Person',
        xAxisData: ['No    \nSchooling', 'Pre-Primary \nSchools  ', 'Primary \n Schools ', 'Junior   \n Secondary\nSchools  ', 'Senior   \nSecondary\nSchools  ', 'Junior   \nColleges\n  and Above'],
        menValuesBar: [
            '14455827',
            '27868882',
            '164893183',
            '263448804',
            '116996970',
            '111859915',
        ],
        womenValuesBar: [
            '34140110',
            '25486963',
            '184765550',
            '223646206',
            '95212952',
            '105364736',
        ],
    },
    echart5: {
        title: 'Illiterate Population and Illiterate Rate from Population Censuses',
        unitBar: '10000 Persons',
        unitLine: '%',
        valuesBar: [
            '23327',
            '22996',
            '18003',
            '8507',
            '5466',
            '3775',
        ],
        valuesLine: [
            '33.58',
            '22.81',
            '15.88',
            '6.72',
            '4.08',
            '2.67',
        ],
        years: [
            '1964',
            '1982',
            '1990',
            '2000',
            '2010',
            '2020'
        ],
    },
    echart6: {
        title: 'Pyramids from 2020 Census of Population',
        unit: '%',
        menValues: [
            '-2.91',
            '-3.41',
            '-3.42',
            '-2.77',
            '-2.81',
            '-3.42',
            '-4.53',
            '-3.61',
            '-3.38',
            '-4.13',
            '-4.33',
            '-3.60',
            '-2.62',
            '-2.58',
            '-1.71',
            '-0.65',
            '-0.31',
            '-0.10',
            '-0.02',
        ],
        womenValues: [
            '2.62',
            '3.00',
            '2.81',
            '2.39',
            '2.50',
            '3.10',
            '4.28',
            '3.41',
            '3.21',
            '3.97',
            '4.26',
            '3.59',
            '2.59',
            '2.67',
            '1.80',
            '1.17',
            '0.80',
            '0.16',
            '0.04',
            '0.01',
        ],
        yAxisData: [
            '0-4',
            '5-9',
            '10-14',
            '15-19',
            '20-24',
            '25-29',
            '30-34',
            '35-39',
            '40-44',
            '45-49',
            '50-54',
            '55-59',
            '60-64',
            '65-69',
            '70-74',
            '75-79',
            '80-84',
            '85-89',
            '90-94',
            '95-99',
            '100 & Over',
        ],
    },
    echart7: {
        title: 'Population Aged 65 & Over from Population Censuses (10000 Persons)',
        unit: '10000 Persons',
        values: [
            '2569.266',
            '2472.7048',
            '4950.1638',
            '6314.5976',
            '8810.1768',
            '11883.3164',
            '19063.528'
        ],
        years: [
            '1953',
            '1964',
            '1982',
            '1990',
            '2000',
            '2010',
            '2020'
        ],
    },
    echart8: {
        title: 'Percentage of Population Aged 65 & Over to Total Population from Population Censuses(%)',
        unit: '%',
        values: [
            '4.41',
            '3.56',
            '4.91',
            '5.57',
            '6.96',
            '8.87',
            '13.5'
        ],
        years: [
            '1953',
            '1964',
            '1982',
            '1990',
            '2000',
            '2010',
            '2020'
        ],
    },
}

export const home = (state = _state, action = {}) => {
    switch (action.type) {
        case (type.handleKeyValue):
            state[[action.key]] = action.value;
            return {...state};
        case type.Get_Count:
            state.dataCount = action.data;
            return {...state};
        case type.GET_YearbookList:
            state.yearbookList = action.data;
            return {...state};
        case type.GET_StatNews:
            state.statNews = action.data;
            return {...state};
        case type.DrawEChart0: {
            state.charts[0] = action.chart;
            return {...state}
        }
        case type.DrawEChart1: {
            state.charts[1] = action.chart;
            return {...state}
        }
        case type.DrawEChart2: {
            state.charts[2] = action.chart;
            return {...state}
        }
        case type.DrawEChart3: {
            state.charts[3] = action.chart;
            return {...state}
        }
        default:
            return state;
    }
}
